import { observable, runInAction } from 'mobx'
import { hashHistory } from 'react-router'
import { isStoreHidden } from '@util'
import { message } from 'hljd'
import Api from '@api/hotel/niuniu'
import { Modal } from 'hljd'
import { EDIT_WEDDING_HALL_PATH } from '@components/Hotel/constant'
import BaseStore from 'hljd/esm/SearchBar/store'

const confirm = Modal.confirm

const SORTER_MAP = {
  'created_at-descend': 1,
  'created_at-ascend': 2,
  'updated_at-descend': 3,
  'updated_at-ascend': 4
}

class Store extends BaseStore {
  $listApi = Api.sitelist
  @observable keys = '1'
  @observable shouldEditVerticalImg = false // 是否显示顶部设置竖图提示
  @observable verticalModalVisible = false // 设置竖图
  @observable currentVerticalImgRecord = {} // 设置竖图的信息
  @observable clipModalVisible = false // 使用宴会厅横图裁剪modal
  @observable clipVerticalImgUrl = '' // 裁剪的竖图

  constructor(key = '1') {
    super()
    this.keys = key
  }

  onChange = tab => {
    this.keys = tab
    this.$getList(1)
  }

  $getParams = () => {
    this.$list = []
    this.$pagination.total = 0
    this.$pagination.current = 0
    const paramsObj = {
      '1': {
        status: 1,
        is_published: 1
      },
      '2': {
        status: 0
      },
      '3': {
        status: 2
      },
      '4': {
        is_published: 0
      }
    }
    const { field, order } = this.$sorter || {}
    let sortKey = null
    if (field && order) {
      sortKey = field + '-' + order
    }
    return {
      ...paramsObj[String(this.keys)],
      sort: sortKey ? SORTER_MAP[sortKey] : null
    }
  }

  toLink = () => {
    let msg = isStoreHidden()
    if (msg == 'success') {
      hashHistory.push(EDIT_WEDDING_HALL_PATH)
    } else {
      message.error(msg)
    }
  }

  menufromsale = id => () => {
    let msg = isStoreHidden()
    if (msg == 'success') {
      confirm({
        title: `是否确认${this.keys == 4 ? '上' : '下'}架此场地?`,
        onOk: async () => {
          let params = {
            id: id,
            btn: this.keys == 4 ? 1 : 2
          }
          const { success } = await Api.sitefromsale(params)
          if (success) {
            this.$getList()
          }
        }
      })
    } else {
      return message.error(msg)
    }
  }

  delLive = id => () => {
    confirm({
      title: '是否确认删除此场地?',
      onOk: async () => {
        let params = {
          id: id,
          btn: 4
        }
        const { success } = await Api.sitefromsale(params)
        if (success) {
          this.$getList()
        }
      }
    })
  }

  edit = id => () => {
    let msg = isStoreHidden()
    if (msg == 'success') {
      hashHistory.push(`${EDIT_WEDDING_HALL_PATH}/${id}`)
    } else {
      return message.error(msg)
    }
  }

  /**
   * 检测是否需要竖图弹窗
   */
  isEditVerticalImage = async () => {
    const { success, data } = await Api.isEditVerticalImage({
      type: 4
    })
    runInAction(() => {
      if (success) {
        this.shouldEditVerticalImg = data
      }
    })
  }

  /**
   * 上传竖图
   */
  toggleVerticalImgModal = (visible, record) => () => {
    this.verticalModalVisible = visible
    if (visible && record) {
      this.currentVerticalImgRecord = record
    }
    if (!visible) {
      this.clipVerticalImgUrl = ''
    }
  }

  toggleClipModalVisible = visible => () => {
    this.clipModalVisible = visible
  }

  onCliped = img => {
    const { clipUrl } = img
    this.submitVerticalImg(clipUrl)
    // this.clipVerticalImgUrl = clipUrl
  }

  onDelete = () => {
    this.clipVerticalImgUrl = ''
  }

  submitVerticalImg = async clipUrl => {
    this.verticalModalVisible = false
    this.$loading = true
    const { success } = await Api.uploadVerticalImg({
      id: this.currentVerticalImgRecord.id,
      vertical_cover_url: clipUrl
    })
    if (success) {
      message.success('上传成功')
      this.$getList()
    }
  }

  /* ————————————————list-设置竖图————————————————*/
  @observable verticalImgVisible = false
  @observable vertical_image = ''

  // 弹窗-打开
  showVerticalImgModal = ({ id, cover_path }) => {
    this.vertical_image = cover_path
    this.current_id = id
    this.verticalImgVisible = true
  }

  // 弹窗-取消
  closeVerticalImgModal = () => {
    this.vertical_image = ''
    this.current_id = ''
    this.verticalImgVisible = false
  }

  // 弹窗-保存
  saveVerticalImgModal = () => {
    // 清空链接，关闭弹窗
    this.closeVerticalImgModal()
  }

  // 图片裁剪
  verticalImgModalonCliped = url => {
    this.vertical_image = url
    this.sendVerticalImg(url)
    this.closeVerticalImgModal()
  }

  // 图片删除
  verticalImgModalonDelete = () => {
    this.vertical_image = ''
  }

  sendVerticalImg = async vertical_cover_url => {
    const { success } = await Api.uploadVerticalImg({
      id: this.current_id,
      vertical_cover_url
    })
    runInAction(() => {
      if (success) {
        message.success('上传成功')
        this.keys = '2'
        this.$getList(1)
      }
    })
  }

  @observable unAuditNumber = 0
  // 获取审核未通过的数量
  getUnAuditNumber = async () => {
    const { success, data } = await Api.getUnAuditNumber(1)
    runInAction(() => {
      if (success) {
        this.unAuditNumber = data.pendingCount
      }
    })
  }
}
export default Store
